function toDangerouslySetHtml(htmlString){
    let toReturn = "";
    if(htmlString)
        toReturn = htmlString;

    return { __html: toReturn };
}

export {toDangerouslySetHtml};